import React from 'react';

interface TrovaLogoMarkProps {
  width?: number;
  height?: number;
}

const TrovaLogoMark: React.FC<TrovaLogoMarkProps> = ({ width = 36, height = 36 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="99.3613 243 120.639 120.639" width={width} height={height} style={{ flexShrink: 0 }}>
    <rect x="99.3613" y="243" width="120.639" height="120.639" rx="30.16" style={{ fill: 'var(--color-primary)' }}/>
    <path d="M147.739 264.435C149.216 264.257 150.713 264.154 152.209 264.126C163.59 263.939 174.981 264.126 186.362 264.126H194.984L195.068 279.79C195.068 280.885 195.358 281.96 195.901 282.905C196.116 283.279 196.406 283.606 196.752 283.868L198.145 284.925L120.871 284.887C124.743 272.59 135.656 265.903 147.739 264.435Z" style={{ fill: 'var(--color-ink)' }}/>
    <path d="M162.243 292.799H180.451L180.536 308.463C180.536 309.557 180.826 310.633 181.368 311.577C181.583 311.951 181.873 312.279 182.219 312.541L183.612 313.597L135.422 313.551C140.369 297.84 153.097 294.043 158.026 293.145C158.933 292.977 161.336 292.799 162.262 292.799H162.243Z" style={{ fill: 'var(--color-ink)' }}/>
    <path d="M171.324 321.472H171.362L171.446 337.136C171.446 338.23 171.736 339.306 172.278 340.25C172.493 340.624 172.783 340.952 173.129 341.213L174.522 342.27L144.503 342.223C149.45 326.512 162.178 322.715 167.106 321.818C168.014 321.649 170.417 321.472 171.343 321.472H171.324Z" style={{ fill: 'var(--color-ink)' }}/>
  </svg>
);

export default TrovaLogoMark;
